import { useEffect } from 'react'
import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ActionRow, GETAllVariables, ObjectDataRecord } from '@types'
import { useOpenForm } from '@hooks'
import { useExecuteCommandMutation } from '@redux/api'
import { handleOpenFormAction } from '@components/DisplayForm/helpers'
import { VariableRowType } from '@pages/Variables/types'
import { getValuesFromVariables } from '@helpers'

type Props = {
  actions?: ActionRow[]
  dialogId?: string
  outerVariables: GETAllVariables | undefined
  objectData?: ObjectDataRecord | ObjectDataRecord[]
  preFillObjectData?: ObjectDataRecord | ObjectDataRecord[]
  formVariables: VariableRowType[]
}

export const useOnInitOpenForm = (props: Props) => {
  const { actions, dialogId, outerVariables, objectData, preFillObjectData } = props

  const { openForm } = useOpenForm()
  const [executeCommand] = useExecuteCommandMutation()

  useEffect(() => {
    actions?.forEach(action => {
      if (
        (action.actionCode === ACTION_CODE.OPEN_FORM_MODEL ||
          action.actionCode === ACTION_CODE.OPEN_ANOTHER_FORM_MODEL) &&
        action.eventCode === EVENT_CODE.ON_INIT_FORM
      ) {
        handleOpenFormAction({
          action,
          openForm,
          executeCommand,
          dialogId,
          context: {
            row: objectData,
            preFillObjectData,
            objectData,
            outerVariables: outerVariables ? getValuesFromVariables(outerVariables) : {},
          },
        })
      }
    })
  }, [])
}
